import React from 'react';
import { Leaf, Ban, Recycle, Heart, ShieldCheck, Globe } from 'lucide-react';

const EticaproSection = () => {
  const valoriEticapro = [
    {
      icona: Ban,
      titolo: "No Settori Controversi",
      descrizione: "I tuoi premi non finanzieranno mai armi, tabacchi, combustibili fossili o altri settori dannosi"
    },
    {
      icona: Recycle,
      titolo: "Economia Circolare",
      descrizione: "Sosteniamo progetti di economia circolare e sviluppo sostenibile del territorio"
    },
    {
      icona: Heart,
      titolo: "Economia Civile",
      descrizione: "Alimentiamo un sistema economico basato su reciprocità, fiducia e bene comune"
    },
    {
      icona: Globe,
      titolo: "Impatto Positivo",
      descrizione: "Ogni polizza contribuisce a generare valore sociale e ambientale misurabile"
    }
  ];

  return (
    <section id="eticapro" className="py-20 bg-gradient-to-b from-[#5FB76E]/5 to-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-32 h-32 border-4 border-[#5FB76E] rounded-full"></div>
        <div className="absolute bottom-20 right-20 w-48 h-48 border-4 border-[#3AAFA9] rounded-full"></div>
        <div className="absolute top-1/2 left-1/3 w-24 h-24 border-4 border-[#2B7A9F] rounded-full"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <span className="inline-block px-4 py-2 bg-[#5FB76E]/10 text-[#5FB76E] rounded-full text-sm font-semibold mb-4">
            Assicurazione Etica
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-[#2B7A9F] mb-6">
            Accreditati{' '}
            <span className="text-[#5FB76E]">Eticapro</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Essere accreditati Eticapro significa garantire che le tue coperture assicurative 
            siano coerenti con i valori di sostenibilità e responsabilità sociale.
          </p>
        </div>

        {/* Main Content */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Left - Main Message */}
          <div className="animate-fade-in-up">
            <div className="bg-white rounded-2xl p-8 shadow-xl border border-gray-100">
              <div className="flex items-start space-x-4 mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-[#5FB76E] to-[#3AAFA9] rounded-xl flex items-center justify-center flex-shrink-0 shadow-lg">
                  <ShieldCheck className="text-white" size={32} />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    Cosa significa scegliere Assietica?
                  </h3>
                  <p className="text-[#5FB76E] font-semibold">Agenzia Assimoco accreditata Eticapro</p>
                </div>
              </div>
              
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p className="text-lg">
                  Scegliere noi significa che i tuoi <strong className="text-[#2B7A9F]">premi assicurativi 
                  non alimentano settori controversi</strong> come armi, tabacchi, gioco d'azzardo 
                  o combustibili fossili.
                </p>
                <p className="text-lg">
                  Al contrario, <strong className="text-[#5FB76E]">sostengono l'economia civile</strong> attraverso 
                  un progetto di economia circolare che genera valore per le comunità e il territorio.
                </p>
                <p className="text-lg">
                  È la garanzia che la tua protezione assicurativa sia <strong className="text-[#3AAFA9]">coerente 
                  con la missione sociale</strong> del tuo ente.
                </p>
              </div>
            </div>
          </div>

          {/* Right - Values Grid */}
          <div className="grid grid-cols-2 gap-4 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            {valoriEticapro.map((valore, index) => {
              const IconComponent = valore.icona;
              return (
                <div
                  key={index}
                  className="group bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100"
                >
                  <div className="w-12 h-12 bg-gradient-to-br from-[#5FB76E]/20 to-[#3AAFA9]/20 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="text-[#5FB76E]" size={24} />
                  </div>
                  <h4 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-[#5FB76E] transition-colors duration-300">
                    {valore.titolo}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {valore.descrizione}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="bg-gradient-to-r from-[#5FB76E] to-[#3AAFA9] rounded-2xl p-8 sm:p-12 text-white shadow-2xl animate-fade-in-up">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
            <div className="text-center lg:text-left">
              <h3 className="text-2xl sm:text-3xl font-bold mb-4">
                Protezione assicurativa che rispetta i tuoi valori
              </h3>
              <p className="text-lg text-white/90 max-w-2xl">
                Con Assietica, ogni premio versato contribuisce a costruire un'economia 
                più giusta, sostenibile e solidale. È la scelta coerente per chi opera nel Terzo Settore.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EticaproSection;
